/* global axios */
import ApiClient from './ApiClient';

class SoftphoneAPI extends ApiClient {
  constructor() {
    super('softphone', { accountScoped: true });
  }

  caller(number) {
    return axios.get(`${this.url}/caller`, { params: { number } });
  }

  calls() {
    return axios.get(`${this.url}/calls`);
  }
}

export default new SoftphoneAPI();
